import './style.scss'
import { Translator, Alert } from '@itarget/shared'
import {
  Container,
  Divider,
  Typography,
  Grid,
  makeStyles,
} from '@material-ui/core'
import Layout from '../../../components/Layout'
import Model1 from '../../../components/CardOffers/Model1'
import Model2 from '../../../components/CardOffers/Model2'
import Model3 from '../../../components/CardOffers/Model3'
import Model4 from '../../../components/CardOffers/Model4'
import Model5 from '../../../components/CardOffers/Model5'
import { enumsOffers,  ModalPendingCategoryCertificate } from '@itarget/shared'
import { useState } from 'react'

const useStyles = makeStyles((theme) => ({
  modelsContainer: {
    '& > .MuiGrid-item': {
      [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
        marginBottom: theme.spacing(1.5),
      },
      [theme.breakpoints.up(theme.breakpoints.values.xs)]: {
        padding: theme.spacing(2.5, 0),
      },
      [theme.breakpoints.up(theme.breakpoints.values.sm)]: {
        padding: theme.spacing(2.5, 2),
      },
      [theme.breakpoints.up(theme.breakpoints.values.md)]: {
        padding: theme.spacing(2.5, 1),
      },
      [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
        padding: theme.spacing(1.5, 1),
      },
      [theme.breakpoints.up(theme.breakpoints.values.xl)]: {
        padding: theme.spacing(1.5, 1),
      },
    },
  },
}))

const OffersView = ({
  alert,
  handleCloseAlert,
  offers,
  selectOffer,
  categorySelected,
  category,
  groupByOffers,
  center_cost_id,
  toast,
  user
}) => {
  const styles = useStyles()
  const [showModalPendingCategoryCertificate, setShowModalPendingCategoryCertificate] = useState(false)
  function OffersModal(props) {
    const { offers, conditionModel, selectOffer } = props
    const list = Array.isArray(offers)
      ? offers
      : Object.values(offers || {}).reduce((acc, cur) => acc.concat(cur), [])
    return list.map((row, i) => (
      <Grid key={i} container item xs={12} sm={6} md={4} lg={3}>
        {conditionModel === 1 && <Model1 card={row} onClick={selectOffer} />}
        {conditionModel === 2 && <Model2 card={row} onClick={selectOffer} />}
        {conditionModel === 3 && <Model3 card={row} onClick={selectOffer} />}
        {conditionModel === 4 && <Model4 card={row} onClick={selectOffer} />}
        {conditionModel === 5 && <Model5 card={row} onClick={selectOffer} />}
      </Grid>
    ))
  }

  function handleShowModalPendingCategoryCertificate(show){
    setShowModalPendingCategoryCertificate(show)
  }

  return (
    <Layout>
      {alert.open && (
        <Alert.Root>
          <Alert.Container>
            <Alert.Title icon="lock"><Translator transRef='translation.Programa cashback bloqueado' /></Alert.Title>
            <Alert.Content>{alert.message}</Alert.Content>
          </Alert.Container>
          <Alert.CloseButton onClose={handleCloseAlert} />
        </Alert.Root>
      )}
      <Container maxWidth="xl" className="offers-header title-page">
        <Typography variant="h4">
          <Translator transRef="translation.VITRINE" />
        </Typography>
      </Container>
      <Divider />
      <Container maxWidth="xl" className="offers-body">
        <Typography
          style={{
            display:
              (Array.isArray(offers)
                ? offers.length !== 0
                : Object.keys(offers || {}).length !== 0) && 'none',
          }}
          variant="h6"
        >
          {categorySelected && category?.data?.length > 1 ? (
            <Translator transRef="translation.Selecione sua categoria para exibir os cursos" />
          ) : (Array.isArray(offers)
              ? offers.length === 0
              : Object.keys(offers || {}).length === 0) ? (
            <Translator transRef="translation.Sem itens cadastrados" />
          ) : (
            ''
          )}
        </Typography>

        <Grid item xs={12} className={styles.modelsContainer} container>
          {groupByOffers ? (
            Object.entries(offers).map(([title, offer], i) => {
              return (
                <>
                  <Grid key={i} item xs={12}>
                    <Typography>{title}</Typography>
                  </Grid>
                  <OffersModal
                    offers={offer}
                    conditionModel={enumsOffers.CONDITIONAL_MODEL}
                    selectOffer={selectOffer}
                    onClickRegistered={selectOffer}
                  />
                </>
              )
            })
          ) : (
            <OffersModal
              offers={offers}
              conditionModel={enumsOffers.CONDITIONAL_MODEL}
              selectOffer={selectOffer}
              onClickRegistered={selectOffer}
            />
          )}
        </Grid>
        <ModalPendingCategoryCertificate
          costCenterId={center_cost_id}
          lang={'pt-br'}
          personId={user?.data?.id}
          toast={toast}
          open={showModalPendingCategoryCertificate}
          setOpen={handleShowModalPendingCategoryCertificate}
        />
      </Container>
    </Layout>
  )
}

export default OffersView
